import {
  Building2, Calculator, CalendarDays, Camera, ChartColumn, ChartPie, ClipboardCheck, ClipboardList,
  Clock, FileSpreadsheet, FileText, FolderOpen, Gauge, Hammer, Handshake, HardHat, LayoutGrid,
  ListChecks, MapPin, Package, PaintRoller, Receipt, Ruler, Share2, ShieldCheck, Truck, UserCog,
  Users, Wrench, type LucideIcon,
} from 'lucide-react';

/**
 * The curated icons a tile can use, stored in Dataverse by NAME (kebab-case,
 * as lucide names them). An unknown name — a typo, or an icon dropped from
 * this list later — draws the generic grid icon, so it can never break a page.
 * Add to this list freely; nothing else needs to change.
 */
export const TILE_ICONS: Record<string, LucideIcon> = {
  'share-2': Share2,
  'calendar-days': CalendarDays,
  'clipboard-list': ClipboardList,
  'clipboard-check': ClipboardCheck,
  'file-spreadsheet': FileSpreadsheet,
  'file-text': FileText,
  'folder-open': FolderOpen,
  ruler: Ruler,
  'shield-check': ShieldCheck,
  wrench: Wrench,
  hammer: Hammer,
  'paint-roller': PaintRoller,
  'hard-hat': HardHat,
  truck: Truck,
  'map-pin': MapPin,
  'building-2': Building2,
  'user-cog': UserCog,
  users: Users,
  handshake: Handshake,
  'chart-column': ChartColumn,
  'chart-pie': ChartPie,
  gauge: Gauge,
  calculator: Calculator,
  receipt: Receipt,
  camera: Camera,
  package: Package,
  clock: Clock,
  'list-checks': ListChecks,
};

const FALLBACK_ICON: LucideIcon = LayoutGrid;

/** Brand primaries at full strength only — no tints (Brand Guidelines §1). */
export const TILE_COLOURS = {
  orange: { label: 'Orange', hex: '#ff8300' },
  purple: { label: 'Purple', hex: '#8b189b' },
  charcoal: { label: 'Charcoal', hex: '#252729' },
} as const;

export type TileColour = keyof typeof TILE_COLOURS;

export function tileIcon(name: string): LucideIcon {
  return TILE_ICONS[name] ?? FALLBACK_ICON;
}

export function tileHex(colour: string): string {
  return (TILE_COLOURS as Record<string, { hex: string }>)[colour]?.hex ?? TILE_COLOURS.charcoal.hex;
}
